import type ApplicationInstance from '@ember/application/instance';

export function initialize(appInstance: ApplicationInstance) {
  appInstance.lookup('service:scroll-manager');
}

export default {
  name: 'scroll-manager',
  initialize,
};
